import React from 'react';
import classNames from 'classnames';
import styles from './SVGIcon.scss';

export default function BankAccountIcon({ className, size = 'tiny' }) {
  return (
    <span className={classNames(styles.svgIcon, className, styles[size])}>
      <svg viewBox="0 0 24 22" fill="var(--color-icon-lineart)">
        <g>
          <rect x="0.64" y="20.72" width="22.72" height="1.28" />
          <path
            d="M23.6,5.73,12.24,1.05a.57.57,0,0,0-.48,0L.4,5.73a.63.63,0,0,0-.35.83A.64.64,0,0,0,.64,7H23.36A.64.64,0,0,0,24,6.32a.65.65,0,0,0-.39-.59ZM3.87,5.68,12,2.33l8.13,3.35Z"
            transform="translate(0 -1)"
          />
          <rect x="20.05" y="7.32" width="1.28" height="12.03" />
          <rect x="16.71" y="7.32" width="1.28" height="12.03" />
          <rect x="6.01" y="7.32" width="1.28" height="12.03" />
          <rect x="2.67" y="7.32" width="1.28" height="12.03" />
          <rect x="13.12" y="7.32" width="1.28" height="12.03" />
          <rect x="9.77" y="7.32" width="1.28" height="12.03" />
        </g>
      </svg>
    </span>
  );
}
